export const primaryColor = "#ff8a00";
